import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { DocumentType } from '../models/document-type';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentTypesService extends CrudService implements AdvancedService<DocumentType> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<DocumentType>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/DocumentTypes`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<DocumentType>(DocumentType, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/Organizations/${this.organizationId}/DocumentTypes/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(documentTypeId: number, documentType: DocumentType): Observable<DocumentType> {
        // Appel de la Web Api
        return this.http
            .put<DocumentType>(this.baseUrl + `/api/Organizations/${this.organizationId}/DocumentTypes/${documentTypeId}`, documentType, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    return x;
                })
            );
    }

    delete(documentTypeId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http.delete<DocumentType>(this.baseUrl + `/api/Organizations/${this.organizationId}/DocumentTypes/${documentTypeId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(DocumentType: DocumentType): Observable<DocumentType> {
        // Appel de la Web Api
        return this.http.post<DocumentType>(this.baseUrl + `/api/Organizations/${this.organizationId}/DocumentTypes`, DocumentType, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    get(documentTypeId: number): Observable<DocumentType> {
        // Appel de la Web Api
        return this.http.get<DocumentType>(this.baseUrl + `/api/Organizations/${this.organizationId}/DocumentTypes/${documentTypeId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
